


































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import { RootGettersReturns } from '../../../store/types';
import { ElementActionsKeys, ElementActionsPayload } from '../../../store/types/element';
import { StageActionsKeys, StageActionsPayload } from '../../../store/types/stageState';
import { getFileUrl } from '@/utils';

@Component({})
export default class PdfToolbar extends Vue {
  @Prop(Boolean) isShared!: boolean;
  @Prop(Boolean) isLocked!: boolean;
  @Prop(Boolean) isUsed!: boolean;
  @Prop(Function) lock!: () => void;
  @Getter selectedElement!: RootGettersReturns['selectedElement'];
  @Getter currentUser!: RootGettersReturns['currentUser'];
  @Getter isGuest!: RootGettersReturns['isGuest'];
  @Getter focusState!: RootGettersReturns['focusState'];
  @Getter sharedBoard!: RootGettersReturns['sharedBoard'];
  @Action(ElementActionsKeys.UPDATE_ELEMENT) updateElement!: (payload: ElementActionsPayload['UPDATE_ELEMENT']) => void;
  @Action(StageActionsKeys.SET_FOCUS) focus!: (payload: StageActionsPayload['SET_FOCUS']) => void;

  uuid = '';
  url = '';
  data!: {
    uuid: string;
    pages: number;
    currentPage: number;
    filename: string;
  };

  inputText = this.formatText();

  formatText() {
    if (this.data) {
      return `${this.data.currentPage}/${this.data.pages}`;
    } else {
      return '';
    }
  }

  canPrev = false;
  canNext = false;

  async mounted() {
    await this.setData();
  }

  @Watch('selectedElement', { deep: true })
  async setData() {
    if (!this.selectedElement) return;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.data = this.selectedElement.data as any;
    this.uuid = this.data.uuid;
    this.canPrev = this.data.currentPage > 1;
    this.canNext = this.data.currentPage < this.data.pages;
    this.inputText = this.formatText();
    await this.setImageUrl();
  }

  async setImageUrl() {
    this.url = await getFileUrl(this.data.filename);
  }

  updatePage(page: number) {
    if (this.selectedElement) {
      this.updateElement({
        ...this.selectedElement,
        data: {
          ...this.selectedElement.data,
          currentPage: page,
          usedBy: this.currentUser?.id,
        },
      });
      this.data.currentPage = page;
      this.canPrev = page > 1;
      this.canNext = page < this.data.pages;
      this.inputText = this.formatText();
      this.lock();
    }
  }

  deleteElement() {
    if (!this.selectedElement) return;
    this.updateElement({
      ...this.selectedElement,
      deleted: true,
    });
  }

  focusElement() {
    if (!this.selectedElement) return;
    this.focus({ board_element: this.focusState ? null : this.selectedElement, withPrevState: true });
  }

  async share() {
    if (!this.selectedElement) return;
    await this.updateElement({
      ...this.selectedElement,
      data: {
        ...this.selectedElement.data,
        shared: !(this.selectedElement.data as { shared: boolean }).shared,
        usedBy: false,
      },
    });
    this.$root.$emit('cancelDouble');
  }

  async unlock() {
    if (!this.selectedElement) return;
    await this.updateElement({
      ...this.selectedElement,
      data: {
        ...this.selectedElement.data,
        usedBy: false,
      },
    });
    this.$root.$emit('cancelDouble');
  }
}
